import Button from 'components/Button';
import DropdownAction from 'components/DropdownAction';
import ButtonLocale from 'components/Locale/ButtonLocale';
import {FC} from 'react';
import {t} from 'ttag';
import {setUrl} from 'utils/request';

import {SessionStatus} from '../../../hooks/useSessionTimer';
import {menuButton} from './styles.module.css';

type LoggedInMenuProps = {
    email: string;
    sessionStatus: SessionStatus;
};

const LoggedInMenu: FC<LoggedInMenuProps> = ({email, sessionStatus}) => {
    return (
        <DropdownAction
            ariaLabel="loggedInMenu"
            classNameContainer="w-72 p-4"
            classNameIcon="text-grey-800"
            hasCaret={false}
            icon="user"
            kind="tertiary"
            label=""
            layoutOffset={-5}
            size="sm"
        >
            <div className="pointer-events-auto flex flex-col text-base">
                <div className="wrap-mail-text font-semibold">{email}</div>
                <div className="mb-2 border-b border-grey-300 pb-4 text-grey-500">
                    {sessionStatus.label}
                </div>
                <ButtonLocale
                    className={menuButton}
                    isAlignedCenter={false}
                    size="sm"
                />
                <Button
                    className={menuButton}
                    icon="logout"
                    isAlignedCenter={false}
                    kind="tertiary"
                    onClick={() => {
                        setUrl('/portal/logout/');
                    }}
                    size="sm"
                >
                    {t`Logout`}
                </Button>
            </div>
        </DropdownAction>
    );
};

export default LoggedInMenu;
